import * as actionTypes from '../actions'

const initialState: any = { 
    id: 0,
    show: false,
    cartInfo: [],
    totalAmount: 0,
    taxAmountTotal: 0,
    consumptionTaxAmountTotal: 0,
    active: false,
    cartState: false,
    clientId: 0,
    date: false,
    error: false,
    publicKey: '',
    loading: false,
    recentlyDelete: false,
    customShippingValue:0,
    inSummaryPage: false,
    contactName: '',
    contactLastname: '',
    contactPhone: '',
    contactEmail: '',
    catalogueId: '',
    find: [],
    update: false,
    refId: null,
    shippingCost: 0
}

const shoppingCartReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.LOADING_CART: {
            return {
                ...state,
                loading: true
            }
        }

        case actionTypes.SHOW_CART: {
            return {
                ...state,
                show: true,
                active: true
            }
        }
        case actionTypes.HIDE_CART: {
            return {
                ...state,
                show: false,        
            }
        }
        case actionTypes.REF_PRODUCT_EDIT: {
            return {
                ...state,
                refId: action.payload.refId,        
            }
        }
        case actionTypes.ADD_PRODUCT: {
            //sessionStorage.setItem("shoppingCart", JSON.stringify(action.payload))
        return {
            ...state,
            id: action.payload.id,
            totalAmount: action.payload.total,
            taxAmountTotal: action.payload.taxAmountTotal,
            consumptionTaxAmountTotal: action.payload.consumptionTaxAmountTotal,
            cartState: action.payload.state,
            date: action.payload.date,
            clientId: action.payload.clientId,
            publicKey: action.payload.publicKey,
            cartInfo: action.payload.products,
            contactName: action.payload.contactName,
            contactPhone: action.payload.contactPhone,
            contactEmail: action.payload.email,
            catalogueId: action.payload.catalogueId,
            loading: false,
            update: false,
            shippingCost: action.payload.shippingCost,
          }
        }

       /*  case actionTypes.EDIT_PRODUCT: {
            //sessionStorage.setItem("shoppingCart", JSON.stringify(action.payload))
        return {
            ...state,
            id: action.payload.id,
            totalAmount: action.payload.total,
            cartState: action.payload.state,
            date: action.payload.date,
            clientId: action.payload.clientId,
            cartInfo: action.payload.products,
            loading: false
        }
        } */

        case actionTypes.UPDATE_TOTAL_PRICE: {
            return {
                ...state,
                totalAmount: (state.totalAmount + action.payload)
            }
        }
        case actionTypes.DISCARD_PRODUCT: {
            return {
                ...state,
                cartInfo: [...state.cartInfo].filter(field => field.id !== action.payload),
            }; 
        }
        case actionTypes.CART_ERROR: {
            return {
                ...state,
                show: false,
                cartState: false,
                loading: false,
                error: true
            }; 
        }
        case actionTypes.EMPTY_CAR: {
            return initialState
        }
         case actionTypes.DEACTIVATED_CART: {
            return initialState
        }
        case actionTypes.IN_SUMMARY_PAGE: {
            return {
                ...state,
                inSummaryPage: action.payload
            }
        }
        case actionTypes.CUSTOM_SHIPPING_VALUE: {
            return {
                ...state,
                customShippingValue: action.payload
            }; 
        }
        case actionTypes.FIND_SHOPPING_CART: {
            return {
                ...state,
                find: action.payload
            }; 
        }
        case actionTypes.UPDATE_QUANTITY_COUNTER: {
            return {
                ...state,
                update: true,
                cartInfo: [...action.payload],
            }; 
        }
        case actionTypes.UPDATE_TAX: {
            return {
                ...state,
                taxAmountTotal: action.payload.taxAmountTotal,
                consumptionTaxAmountTotal: action.payload.consumptionTaxAmountTotal
            }; 
        }
        default: {
            return state
        }
    }
}

export default shoppingCartReducer
